import React, { useState, useContext } from "react";
import { OperacaoContext } from "../../../context/OperacaoContext";
import { useNavigate, useLocation } from "react-router-dom";
import whatsappBgImg from "../../../assets/whatsapp-bg.png";
import "./EtapaEnvio.css";
import "bootstrap/dist/css/bootstrap.min.css";

// Função para renderizar texto com formatação personalizada
const renderComFormatacao = (texto) => {
  if (!texto) return null;

  const partes = texto.split(/(\*.*?\*|_.*?_|~.*?~)/g);

  return partes.map((parte, index) => {
    if (/^\*.*\*$/.test(parte)) {
      return <strong key={index}>{parte.slice(1, -1)}</strong>;
    } else if (/^_.*_$/.test(parte)) {
      return <em key={index}>{parte.slice(1, -1)}</em>;
    } else if (/^~.*~$/.test(parte)) {
      return <s key={index}>{parte.slice(1, -1)}</s>;
    } else {
      return parte;
    }
  });
};


const EtapaEnvio = ({ notifyColor, contasSelecionadas = [], gruposSelecionados = [], mensagens = [], mencionarTodos, novoNome = "", mensagem: propMensagem = "", gatilhoSelecionado = "", acaoSelecionada = "" }) => {
  const [delayEnabled, setDelayEnabled] = useState(false);
  const [delayValue, setDelayValue] = useState(1);
  const [delayUnit, setDelayUnit] = useState("minutos");
  const location = useLocation();
  const [nomeAutomacao, setNomeAutomacao] = useState("");
  // Busca dados do admin vindos da navegação
  const adminAdicionado = location?.state?.adminAdicionado;
  // Adiciona os dados do admin como mensagem no array, se existirem
  const mensagensComAdmin = adminAdicionado
    ? [...mensagens, { tipo: "texto", conteudo: `Administrador: ${adminAdicionado.nome} - ${adminAdicionado.numero}` }]
    : mensagens;
  const navigate = useNavigate();
  const { setOperacoes } = useContext(OperacaoContext);
  // Detecta se está em modo de edição e o índice
  let idxEdicao = null;
  if (location && location.state && typeof location.state.idx === 'number') {
    idxEdicao = location.state.idx;
  } else if (window.history && window.history.state && window.history.state.usr && typeof window.history.state.usr.idx === 'number') {
    idxEdicao = window.history.state.usr.idx;
  }


  // Função para enviar operação imediatamente
  const handleEnviarAgora = () => {
    // Prioriza a mensagem passada pela prop (por exemplo de Removeradm)
    let mensagensParaSalvar = (mensagens && mensagens.length > 0)
      ? mensagens
      : (propMensagem ? [{ tipo: 'texto', conteudo: propMensagem }] : (novoNome ? [{ tipo: 'texto', conteudo: novoNome }] : []));
    // Se for operação de mudar descrição, garantir que o tipo seja descricao
    if (mensagens && mensagens.length === 1 && mensagens[0].tipo === 'descricao') {
      mensagensParaSalvar = mensagens;
    }
    // Se for operação de mudar imagem, garantir que o tipo seja imagem
    if (mensagens && mensagens.length === 1 && mensagens[0].tipo === 'imagem') {
      mensagensParaSalvar = mensagens;
    }
    setOperacoes(prev => {
      const agora = new Date();
      const horaDisparo = agora.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
      // Detecta se é operação de mudar nome ou descrição
      const isMudarNome = !!novoNome;
      const isMudarDescricao = mensagensParaSalvar && mensagensParaSalvar.length === 1 && mensagensParaSalvar[0].tipo === 'descricao';
      const isMudarImagem = mensagensParaSalvar && mensagensParaSalvar.length === 1 && mensagensParaSalvar[0].tipo === 'imagem';
      if (idxEdicao !== null && prev[idxEdicao]) {
        // Atualiza operação existente
        const novas = [...prev];
        novas[idxEdicao] = {
          ...novas[idxEdicao],
          mensagens: mensagensParaSalvar,
          contas: contasSelecionadas,
          grupos: gruposSelecionados,
          mencionarTodos,
          status: 'Enviado',
          data: agora.toLocaleString(),
          horaDisparo,
          novoNome: novoNome,
          tipo: mensagensParaSalvar && mensagensParaSalvar.length === 1 && mensagensParaSalvar[0].tipo === 'config'
            ? 'Mudar Configuração'
            : (isMudarImagem ? 'Mudar Imagem' : (isMudarDescricao ? 'Mudar Descrição' : (isMudarNome ? 'Mudar Nome' : (prev[idxEdicao].tipo || 'Mensagem'))))
        };
        return novas;
      } else {
        // Adiciona nova operação
        return [
          ...prev,
          {
            mensagens: mensagensParaSalvar,
            contas: contasSelecionadas,
            grupos: gruposSelecionados,
            mencionarTodos,
            status: 'Enviado',
            data: agora.toLocaleString(),
            horaDisparo,
            novoNome: novoNome,
            tipo: mensagensParaSalvar && mensagensParaSalvar.length === 1 && mensagensParaSalvar[0].tipo === 'config'
              ? 'Mudar Configuração'
              : (isMudarImagem ? 'Mudar Imagem' : (isMudarDescricao ? 'Mudar Descrição' : (isMudarNome ? 'Mudar Nome' : 'Mensagem')))
          }
        ];
      }
    });
    // navegar para a página de adicionar automação e passar o nome escolhido
      const automacao = {
        id: Date.now(),
        nome: nomeAutomacao || '',
        mensagens: mensagensParaSalvar,
        contas: contasSelecionadas,
        grupos: gruposSelecionados,
        mencionarTodos,
        acao: acaoSelecionada || null,
        gatilho: gatilhoSelecionado || null,
        sentCount: 0,
        failures: 0,
        ativo: true,
      };
      navigate("/adicionarauto", { state: { novaAutomacao: automacao } });
  };


  



  const handleAvancar = () => {
    navigate("/etapa-envio", { state: { contasSelecionadas } });
  };

  return (
    <div
      style={{
        "--notify-color": notifyColor, // Define a cor dinamicamente
      }}
    >
      <h3 style={{ color: notifyColor, marginBottom: 24, textAlign: "center" }}>
        Resumo da operação
      </h3>

      

      <div
        className="etapa-envio-boxes"
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          gap: 16,
          width: "100%",
          maxWidth: 1200,
          margin: "0 auto",
        }}
      >
        {/* Box 1: Operação */}
        <div
          style={{
            background: "#f0f4f8",
            borderRadius: 12,
            padding: 16,
            width: "30%",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            display: "flex",
            flexDirection: "column",
            gap: 12,
          }}
        >
          <div style={{ fontWeight: "bold", color: "#333" }}>Conteúdo:</div>
          <div
            style={{
              color: "#005c53",
              fontWeight: "bold",
              fontSize: 16,
            }}
          >
            Enviar Mensagem
          </div>
          <div
            style={{
              marginTop: 12,
              padding: 16,
              backgroundImage: `url(${whatsappBgImg})`,
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              borderRadius: 8,
              border: "1px solid #ccc",
              maxHeight: "300px",
              overflowY: "auto",
            }}
          >
            {mensagens.length > 0 ? (
              <>
                {mensagensComAdmin.map((msg, index) => (
                  <div
                    key={index}
                    style={{
                      padding: "12px 16px",
                      borderRadius: "16px",
                      background: "#DCF8C6",
                      color: "#333",
                      maxWidth: "80%",
                      marginBottom: 12,
                      wordWrap: "break-word",
                      whiteSpace: "pre-wrap",
                      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.2)",
                      alignSelf: "flex-start",
                    }}
                  >
                    {msg.tipo === "audio" ? (
                      <AudioPlayer src={msg.conteudo} />
                    ) : msg.tipo === "imagem" ? (
                      <img
                        src={msg.conteudo}
                        alt="Imagem selecionada"
                        style={{
                          maxWidth: "100%",
                          borderRadius: "8px",
                          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.2)",
                        }}
                      />
                    ) : msg.tipo === "config" ? (
                        <span style={{ color: notifyColor, fontWeight: "bold" }}>
                          {(() => {
                            const opcoes = [
                              { value: 'admins_mensagens', label: 'Apenas admins enviam mensagens' },
                              { value: 'todos_mensagens', label: 'Todos podem enviar mensagens' },
                              { value: 'admins_config', label: 'Apenas admins mudam as configurações' },
                              { value: 'todos_config', label: 'Todos podem mudar as configurações' },
                            ];
                            const encontrada = opcoes.find(opt => opt.value === msg.conteudo || opt.label === msg.conteudo);
                            return encontrada ? encontrada.label : msg.conteudo;
                          })()}
                        </span>
                    ) : (
                      renderComFormatacao(msg.conteudo)
                    )}
                  </div>
                ))}
              </>
            ) : novoNome ? (
              <div
                style={{
                  padding: "12px 16px",
                  borderRadius: "16px",
                  background: "#DCF8C6",
                  color: "#333",
                  maxWidth: "80%",
                  marginBottom: 12,
                  wordWrap: "break-word",
                  whiteSpace: "pre-wrap",
                  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.2)",
                  alignSelf: "flex-start",
                }}
              >
                {renderComFormatacao(novoNome)}
              </div>
            ) : (
              <div style={{ color: "#888", fontStyle: "italic" }}>
                Nenhuma mensagem selecionada.
              </div>
            )}
          </div>
        </div>

        {/* Box 2: Ação */}
        <div
          style={{
            background: "#f0f4f8",
            borderRadius: 12,
            padding: 16,
            width: "23%",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            display: "flex",
            flexDirection: "column",
            gap: 12,
          }}
        >
          <div style={{ fontWeight: "bold", color: "#333" }}>Ação:</div>
          <div style={{ color: "#005c53", fontWeight: "bold", fontSize: 16 }}>
            {acaoSelecionada ? acaoSelecionada : "Nenhuma ação selecionada."}
          </div>

        </div>

        {/* Box 3: Gatilho */}
        <div
          style={{
            background: "#f0f4f8",
            borderRadius: 12,
            padding: 16,
            width: "23%",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            display: "flex",
            flexDirection: "column",
            gap: 12,
          }}
        >
          <div style={{ fontWeight: "bold", color: "#333" }}>Gatilho:</div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 8,
            }}
          >
              {/* Exibe o gatilho selecionado, se houver */}
              {gatilhoSelecionado ? (
                <div style={{ marginBottom: 8, color: notifyColor, fontWeight: "bold" }}>{gatilhoSelecionado}</div>
              ) : null}

          </div>
        </div>

        {/* Box 4: Grupos */}
        <div
          style={{
            background: "#f0f4f8",
            borderRadius: 12,
            padding: 16,
            width: "23%",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            display: "flex",
            flexDirection: "column",
            gap: 12,
          }}
        >
          <div style={{ fontWeight: "bold", color: "#333" }}>Campanha/Grupo:</div>
          <div
            style={{
              color: "#005c53",
              fontWeight: "bold",
              fontSize: 16,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 8,
            }}
          >
            {gruposSelecionados.length > 0 && gruposSelecionados[0]?.nomeCampanha ? (
              <>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                  {gruposSelecionados[0].fotoCampanha && (
                    <img
                      src={gruposSelecionados[0].fotoCampanha}
                      alt="Capa Campanha"
                      style={{ width: 48, height: 48, borderRadius: '50%', objectFit: 'cover', border: '2px solid #51a197' }}
                    />
                  )}
                  <div>
                    <div>Campanha: {gruposSelecionados[0].nomeCampanha}</div>
                    <div>Grupo: {gruposSelecionados[0].nomeGrupo}</div>
                  </div>
                </div>
              </>
            ) : gruposSelecionados.length > 0 ? (
              gruposSelecionados.join(", ")
            ) : (
              "Nenhum grupo selecionado"
            )}
          </div>
        </div>
      </div>

      {/* botão 'Enviar Agora' movido para baixo do box de nome */}

      {/* Delay control */}
      <div style={{ marginTop: 20, maxWidth: 1200, margin: "20px auto 0", padding: "12px 16px", borderRadius: 8, background: "#fff", boxShadow: "0 1px 4px rgba(0,0,0,0.06)" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16 }}>
          <div style={{ fontWeight: "bold", color: "#333", fontSize: 16 }}>Delay</div>

          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <div
              onClick={() => setDelayEnabled(!delayEnabled)}
              role="button"
              tabIndex={0}
              style={{
                width: 50,
                height: 28,
                borderRadius: 20,
                background: delayEnabled ? notifyColor : "#ccc",
                padding: 4,
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  width: 20,
                  height: 20,
                  borderRadius: "50%",
                  background: "#fff",
                  transform: delayEnabled ? "translateX(22px)" : "translateX(0)",
                  transition: "transform 0.18s ease",
                }}
              />
            </div>
            <span style={{ color: delayEnabled ? notifyColor : "#666", fontWeight: 600 }}>{delayEnabled ? "Ligado" : "Desligado"}</span>
          </div>
        </div>

        {delayEnabled && (
          <div style={{ display: "flex", gap: 12, marginTop: 12, alignItems: "center" }}>
            <input
              type="number"
              min={1}
              value={delayValue}
              onChange={(e) => setDelayValue(Number(e.target.value))}
              style={{ padding: "8px 10px", borderRadius: 8, border: `1px solid ${notifyColor}`, width: 120 }}
            />

            <select
              value={delayUnit}
              onChange={(e) => setDelayUnit(e.target.value)}
              style={{ padding: "8px 10px", borderRadius: 8, border: `1px solid ${notifyColor}` }}
            >
              <option value="minutos">Minutos</option>
              <option value="horas">Horas</option>
            </select>

            <div style={{ color: "#555" }}>
              {`Delay: ${delayValue} ${delayUnit}`}
            </div>
          {/* Nome da automação */}
            {/* Nome da automação (moved below Delay) - removed from here */}
          </div>
        )}
      </div>

      {/* Nome da automação - box separado abaixo do Delay */}
      <div style={{ marginTop: 12, maxWidth: 1200, margin: "12px auto 0", padding: "12px 16px", borderRadius: 8, background: "#fff", boxShadow: "0 1px 4px rgba(0,0,0,0.06)" }}>
        <label style={{ display: "block", fontWeight: "600", marginBottom: 8, color: "#333" }}>Nome para identificação da automação</label>
        <input
          type="text"
          value={nomeAutomacao}
          onChange={(e) => setNomeAutomacao(e.target.value)}
          placeholder="Ex: Promoção semanal - Lista A"
          style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: `1px solid #ddd` }}
        />
      </div>
      <div style={{ display: "flex", justifyContent: "center", marginTop: 24 }}>
        <button
          onClick={handleEnviarAgora}
          style={{
            padding: "16px 32px",
            borderRadius: 12,
            border: "none",
            background: notifyColor,
            color: "#fff",
            fontSize: 18,
            fontWeight: "bold",
            cursor: "pointer",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
          }}
        >
          Cadastrar Automação
        </button>
      </div>
    </div>
  );
};

export default EtapaEnvio;